import axios from 'axios';

export function getStatisticsEmails(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/emails',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getStatisticsEmailsReceived(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/emails-received',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/statistics/emails.js